import React from "react";
import { Paths } from "../../Paths";
import { RegistrationStatus, useRegistrationStatus } from "../provider/RegistrationStatusProvider";
import { Loading } from "../view/common/Loading";
import { Navigate, RouteProps } from "react-router-dom";

type Props = {
    children: React.JSX.Element,
}

export function PrivateRouter(props: Props & RouteProps) {
    const { children } = props;
    
    const registered = useRegistrationStatus();

    const routing = () => {
        // User情報がある場合
        if (registered === RegistrationStatus.REGISTERED) {
            return children;
        // User情報がない場合
        } else if (registered === RegistrationStatus.UNREGISTERED) {
            return <Navigate to={Paths.login} replace/>;
        // User情報が取得中の場合、取得するまで留める
        } else {
            return <Loading/>;
        }
    };
    return routing();
}
